import React, {Component} from 'react';
import './App.css';
import {Button, Card, Container, Grid, Header, Icon, Input, List, Popup, Segment} from 'semantic-ui-react';
import ReactMarkdown from 'react-markdown';

function hashCode(s) {
    let hash = 0, i, chr;
    if (s.length === 0) return hash;
    for (i = 0; i < s.length; i++) {
        chr = s.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}


function mod(n, m) {
    return ((n % m) + m) % m;
}


class SkillCard extends Component {
    render() {
        const color = this.props.colors[mod(hashCode(this.props.name), this.props.colors.length)];
        return <Card fluid raised style={{
            WebkitBoxShadow: '0px 0px 0px 1px #D4D4D5, 0px -6px 0px 0px ' + color + ', 0px 1px 10px 0px #D4D4D5',
            boxShadow: '0px 0px 0px 1px #D4D4D5, 0px -6px 0px 0px ' + color + ', 0px 1px 10px 0px #D4D4D5'
        }}>
            <Card.Content>
                <Grid columns={2}>
                    <Grid.Column>
                        <Grid.Row>
                            <a target="_blank" href={this.props.repo}><Header color='blue'>{this.props.title}</Header></a>
                        </Grid.Row>
                    </Grid.Column>
                    <Grid.Column>
                        <Grid.Row textAlign='right'>
                            <Popup position='top right'
                                   trigger={<Icon style={{color: '#777777'}} name='info circle' float='right'/>}
                                   content={'"Hey Mycroft, install ' + this.props.name.replace(/-/g, ' ') + '"'}
                            />
                        </Grid.Row>
                    </Grid.Column>
                </Grid>

                <Card.Meta>
                    <a target="_blank" href={'https://github.com/' + this.props.github_username}>Author: {this.props.author}</a>
                </Card.Meta>
                <hr style={{borderTop: '0px', borderLeft: '0px', borderRight: '0px', background: 'transparent'}}/>
                <Card.Description>
                    <ReactMarkdown disallowedTypes={['image', 'imagereference']} source={this.props.short_desc}/>
                    <List bulleted>
                        {this.props.examples.map((example, i) => <List.Item key={i}>{example}</List.Item>)}
                    </List>
                    <ReactMarkdown disallowedTypes={['image', 'imagereference']} source={this.props.description} onError={this.onMarkdownError}/>
                </Card.Description>
            </Card.Content>
            <Card.Content extra>
                <Button target="_blank" floated='left'
                        href={this.props.repo}
                        as='a'>
                    GitHub
                </Button>
            </Card.Content>
        </Card>
    }
}

class App extends Component {
    state = {
        skills: [], columns: 1, cardSize: 12, search: '',
        colors: ['#22A7F0', '#2C3E50', '#81CFE0', '#36D7B7', '#C8F7C5', '#EC644B', '#E9D460', '#6C7A89', '#BDC3C7', '#E4F1FE']
    };

    componentWillMount() {
        fetch('https://raw.githubusercontent.com/MycroftAI/mycroft-skills-data/18.02/skill-metadata.json')
            .then(response => response.json())
            .then(skills => this.setState({skills: skills}))
    }

    onSearchChange = e => {
        this.setState({search: e.target.value});
    };

    render() {
        let {search} = this.state;
        search = search.toLowerCase().trim();
        return (
            <Container className='App'>
                <br/>
                <Header size='huge' color='blue'>Mycroft Skills List</Header>
                <Grid padded centered stackable columns={12}>
                    <Grid.Row>
                        <Grid.Column computer={this.state.cardSize}>
                            <Segment raised>
                                <Input fluid icon='search' placeholder='Search...' onChange={this.onSearchChange}/>
                            </Segment>
                            {
                                Object.values(this.state.skills)
                                    .filter(skill => Object.values(skill).map(value => value.toString().toLowerCase().includes(search)).some(a => a))
                                    .map(skill => <SkillCard key={skill.name}
                                                             colors={this.state.colors} {...skill}/>)
                            }
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js